import React from 'react';
import { useStaticQuery, Link, graphql } from "gatsby"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

import useWindowDimensions from '../../hooks/useWindowDimensions';
import RouteNames from '../../routers/RouteNames';
import './Navbar.scss';

const Navbar = () => {
  const { width } = useWindowDimensions();
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
          }
        }
      }
    `
  );

  return (
    <nav id="navbar">
      <Link className="logo logo-button" to={RouteNames.Home}>
        {width > 800 ? data.site.siteMetadata.title : 'Vicente'}
      </Link>
      <label htmlFor="toggle" className="menu-label">
        <FontAwesomeIcon icon={faBars} />
      </label>
      <input
        name="toggle"
        id="toggle"
        type="checkbox"
        className="menu-button"
      />
      <ul>
        <li>
          <Link className="navlink" to={RouteNames.Home}>
            Home
          </Link>
        </li>
        <li>
          <Link className="navlink" to={RouteNames.Blog}>
            Blog
          </Link>
        </li>
        <li>
          <Link className="navlink" to={RouteNames.Contact}>
            Contact
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
